import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ProductsPromoService } from '@core/product-updates-logic';
import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-hired-candidate-hr-promo',
  templateUrl: './hired-candidate-hr-promo.component.html',
  styleUrl: './hired-candidate-hr-promo.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, ButtonComponent, TranslatePipe],
})
export class HiredCandidateHrPromoComponent {
  protected readonly productsPromoService = inject(ProductsPromoService);
}
